import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-toggle-button',
  templateUrl: './toggle-button.component.html',
  styleUrls: ['./toggle-button.component.scss']
})
export class ToggleButtonComponent {
  @Input() leftLabel = "Yes";
  @Input() rightLabel = "No";
  @Input() disabled = false;

  @Input() value = this.rightLabel;
  @Output() valueChange = new EventEmitter<string>();

  toggle(newValue: string): void {
    if (this.value !== newValue) {
      this.value = newValue;
      this.valueChange.emit(newValue);
    }
  }
}
